<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="bins"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.params="{ item }">{{item.params | json}}</template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="excelService(item)">
          <v-icon color="primary">mdi-microsoft-excel</v-icon>
        </v-btn>
        <v-btn icon @click="generateCodes(item)">
          <v-icon color="primary">mdi-qrcode</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.pdf="{ item }">
        <v-btn icon @click="(templateBin = item.bin),(d_genereate_pdf=true)">
          <v-icon color="primary">mdi-eye-outline</v-icon>
        </v-btn>
        <v-btn icon @click="(templateBin = item.bin), (dupload = true)">
          <v-icon color="primary">mdi-upload</v-icon>
        </v-btn>
        <v-btn icon @click="editTpl(item.bin)">
          <v-icon color="primary">mdi-file-document-edit-outline</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.wallet="{ item }">
        <v-btn v-if="item.pkpassType" icon @click="$router.push('/pkpass/'+item.bin)">
          <v-icon color="primary">mdi-apple</v-icon>
        </v-btn>
        <v-btn v-if="item.pkpassType" icon @click="editWalletTpl(item.bin)">
          <v-icon color="primary">mdi-file-document-edit-outline</v-icon>
        </v-btn>
        <v-btn v-if="item.pkpassType" icon @click="(currentBin = item.bin), (dwalletimages = true)">
          <v-icon color="primary">mdi-image</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.bin" />
          <v-spacer></v-spacer>
          <v-btn icon color="primary" :href="$api.resources+'/binedit.html'" link target="blank_">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn @click="d_edit = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              :disabled="currentIdx!=-1"
              v-model="item.bin"
              :error-messages="bin_errors"
              :label="$t('fields.bin')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-text-field
              v-model="item.name"
              :label="$t('fields.name')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-text-field v-model="item.domen" :label="$t('fields.domen')"></v-text-field>
            <v-checkbox v-model="cardautosuffix" :label="$t('fields.cardSuffix')"></v-checkbox>
            <v-text-field v-model="item.pkpassType" :label="$t('fields.passtype')"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm = true" color="primary">{{ $t("button.delete") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{ $t("button.update") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dupload" persistent width="400">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>
            <i18n path="dialog.ttl.template" />
          </span>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" :href="$api.resources+'/binupload.html'" link target="blank_">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn @click="dupload = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="template"
            :label="$t('dialog.txt.template')"
            :placeholder="$t('dialog.txt.template')"
            clearable
            @click.clear="template = null"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="upload" color="primary">
            <i18n path="dialog.btn.upload" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dedittpl" fullscreen>
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>
            <i18n path="dialog.ttl.template" />
          </span>
          <v-spacer></v-spacer>
          <v-btn text @click="uploadTpl" color="primary">
            <i18n path="dialog.btn.save" />
          </v-btn>
          <v-btn
            icon
            color="primary"
            :href="$api.resources+'/binedittpl.html'"
            link
            target="blank_"
          >
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn @click="dedittpl = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="templateSource" auto-grow rows="25"></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dwallet" fullscreen>
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>
            <i18n path="dialog.ttl.walletSett" />
          </span>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" :href="$api.resources+'/binpkpass.html'" link target="blank_">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn @click="dwallet = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="walletSourceText"></v-textarea>
          <vue-json-pretty :data="walletSource" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="setWalletTpl" color="primary">
            <i18n path="dialog.btn.save" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dwalletimages" fullscreen>
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>
            <i18n path="dialog.ttl.walletSett" />
          </span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="primary"
            :href="$api.resources+'/binpkpassimg.html'"
            link
            target="blank_"
          >
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn @click="dwalletimages = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions>
          <v-btn text @click="uploadImgs" color="blue">Upload</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-card>
                <v-card-title>ICON</v-card-title>
                <v-card-text>
                  <v-img :src="$api.link(currentBin, 'icon.png')" contain height="100" />
                </v-card-text>
                <v-card-actions>
                  <v-file-input v-model="images.icon"></v-file-input>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-card-title>ICON 2x</v-card-title>
                <v-card-text>
                  <v-img :src="$api.link(currentBin, 'icon@2x.png')" contain height="100" />
                </v-card-text>
                <v-card-actions>
                  <v-file-input v-model="images['icon@2x']"></v-file-input>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-card-title>LOGO</v-card-title>
                <v-card-text>
                  <v-img :src="$api.link(currentBin, 'logo.png')" contain height="100" />
                </v-card-text>
                <v-card-actions>
                  <v-file-input v-model="images.logo"></v-file-input>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title>STRIP</v-card-title>
                <v-card-text>
                  <v-img :src="$api.link(currentBin, 'strip.png')" height="150" contain />
                </v-card-text>
                <v-card-actions>
                  <v-file-input v-model="images.strip"></v-file-input>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>STRIP 2x</v-card-title>
                <v-card-text>
                  <v-img :src="$api.link(currentBin, 'strip@2x.png')" height="200" contain />
                </v-card-text>
                <v-card-actions>
                  <v-file-input v-model="images['strip@2x']"></v-file-input>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dexcel" fullscreen>
      <v-card>
        <v-card-title>
          <span>CORRECTING EXCEL WITH QR-CODES</span>
          <v-spacer />
          <v-btn @click="dexcel = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="2">
              <v-file-input
                v-model="excel_file"
                class="ml-4"
                label="Select excel file with headers"
              />
            </v-col>
            <v-col cols="4" class="text-center">
              <v-radio-group v-model="excelField" row class="ml-4">
                <v-radio :value="h" :label="h" v-for="(h, i) in excel_fields" :key="i"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-layout>
                <v-flex>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-checkbox v-model="excel_qrcode" label="QR-CODE"></v-checkbox>
                      </div>
                    </template>
                    <span>
                      <i18n path="tooltip.qrcode" />
                    </span>
                  </v-tooltip>
                </v-flex>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-flex v-bind="attrs" v-on="on">
                      <v-checkbox v-model="excel_barcode" label="BARCODE"></v-checkbox>
                    </v-flex>
                  </template>
                  <span>
                    <i18n path="tooltip.barcode" />
                  </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-flex v-bind="attrs" v-on="on">
                      <v-select
                        v-model="excel_frame"
                        :items="ekk_frames"
                        :label="$t('fields.frame4data')"
                        item-text="name"
                        return-object
                      ></v-select>
                    </v-flex>
                  </template>
                  <span>
                    <i18n path="tooltip.framecode" />
                  </span>
                </v-tooltip>
              </v-layout>
            </v-col>
            <v-col cols="2" align-self="center" class="text-right">
              <v-btn v-if="excel_json.length" text color="blue" @click="addCodes">
                <i18n path="button.addCodes" />
              </v-btn>
              <v-btn v-if="excel_json.length" text color="blue" @click="saveExcel">
                <i18n path="button.save" />
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="white">
                  <td :colspan="excel_headers.length" align="left">
                    <v-pagination
                      v-if="excel_json.length"
                      v-model="excel_cur_page"
                      :length="Math.floor((excel_json.length+10) / excel_max)"
                      :total-visible="10"
                    ></v-pagination>
                  </td>
                </tr>
                <tr>
                  <th v-for="(h, i) in excel_headers" :key="i" :class="colorForHeader(h)">{{ h }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in excel_page" :key="ind">
                  <td v-for="(h, i) in excel_headers" :key="i">{{ item[h] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="d_genereate_pdf" persistent width="400">
      <v-card class="yellow lighten-5">
        <v-card-title>
          <i18n path="dialog.ttl.generatePdf" />
          <v-spacer />
          <v-btn @click="d_genereate_pdf = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="cardpdf">
            <v-text-field :prefix="templateBin" v-model="pdf_card" :label="$t('fields.shortcard')"></v-text-field>
            <v-text-field v-model="pdf_ref" :label="$t('fields.ref_num')"></v-text-field>
            <v-radio-group v-model="pdf_lang" row>
              <v-radio label="LV" value="lv"></v-radio>
              <v-radio label="EE" value="ee"></v-radio>
              <v-radio label="RU" value="ru"></v-radio>
              <v-radio label="EN" value="en"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="blue" @click="showPdf">
            <i18n path="button.generatePdf" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="d_generate_codes" persistent width="800">
      <v-card class="yellow lighten-5">
        <v-card-title>
          <i18n path="dialog.ttl.generateCodes" />
          <v-spacer />
          <v-btn @click="d_generate_codes = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field :prefix="currentBin" v-model="pdf_card" :label="$t('fields.shortcard')"></v-text-field>
            </v-col>
            <v-col>
              <v-select
                v-model="excel_frame"
                :items="ekk_frames"
                :label="$t('fields.frame4data')"
                item-text="name"
                return-object
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="cardCodes">
            <v-col cols="12">
              <div class="text-h6">
                <i18n path="label.cardqrcode" />
                <v-icon @click="$api.copyText('cardinfoQr')" class="ml-4">mdi-content-copy</v-icon>
              </div>
              <a :href="cardCodes.qr" target="_blank">
                <div id="cardinfoQr">{{cardCodes.qr}}</div>
              </a>
            </v-col>
            <v-col cols="12">
              <div class="text-h6">
                <i18n path="label.cardframecode" />
                <v-icon @click="$api.copyText('cardinfoFrame')" class="ml-4">mdi-content-copy</v-icon>
              </div>
              <a :href="cardCodes.frame" target="_blank">
                <div id="cardinfoFrame">{{cardCodes.frame}}</div>
              </a>
            </v-col>
            <v-col cols="12">
              <div class="text-h6">
                <i18n path="label.cardbarcode" />
                <v-icon @click="$api.copyText('cardinfoBar')" class="ml-4">mdi-content-copy</v-icon>
              </div>
              <a :href="cardCodes.bar" target="_blank">
                <div id="cardinfoBar">{{cardCodes.bar}}</div>
              </a>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="blue" @click="getCardCodes">
            <i18n path="button.generatePdf" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{ $t("dialog.txt.delBin") }}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import VueJsonPretty from "vue-json-pretty";
import XLSX from "xlsx";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "AdminBins",
  mixins: [commonmixin],
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      currentIdx: -1,
      item: {},
      images: {},
      pdf_card: "",
      pdf_ref: "",
      pdf_lang: "lv",
      excel_max: 10,
      cardCodes: null,
      dexcel: false,
      excel_qrcode: true,
      excel_barcode: true,
      excel_frame: null,
      excel_file: null,
      excel_cur_page: 1,
      excel_json: [],
      excel_fields: [],
      workbook: null,
      worksheet: null,
      excelField: "",
      dupload: false,
      dwallet: false,
      dedittpl: false,
      d_genereate_pdf: false,
      dwalletimages: false,
      template: null,
      currentBin: null,
      currentDomen: null,
      templateBin: "",
      templateSource: "",
      walletSource: {},
      d_edit: false,
      d_generate_codes: false,
      bin_errors: "",
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: this.$t("fields.pdf"),
          value: "pdf",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: this.$t("fields.wallet"),
          value: "wallet",
          sortable: false,
          align: "center",
          width: 150,
        },
        { text: this.$t("fields.bin"), value: "bin" },
        { text: this.$t("fields.domen"), value: "domen" },
        { text: this.$t("fields.passtype"), value: "pkpassType" },
        { text: this.$t("fields.params"), value: "params" },
        { text: this.$t("fields.name"), value: "name" },
      ],
    };
  },
  watch: {
    excel_file: {
      handler(file) {
        if (!file) {
          this.workbook = null;
          this.worksheet = null;
          this.excel_json = [];
          this.excel_fields = [];
          return;
        }
        const reader = new FileReader();
        reader.addEventListener("load", (event) => {
          try {
            let data = event.target.result;
            this.workbook = XLSX.read(data, { type: "binary" });
            const first_sheet_name = this.workbook.SheetNames[0];
            this.worksheet = this.workbook.Sheets[first_sheet_name];
            this.excel_json = XLSX.utils.sheet_to_json(this.worksheet);
            //             if (this.excel_json.length) {
            //               for (let i in this.excel_json[0]) {
            //                 this.excel_fields.push(i);
            //                 break;
            //               }
            //             }

            this.excel_fields = [...this.excel_headers];
            this.excelField = this.excel_fields[0];
          } catch (e) {
            console.log(e);
          }
        });
        reader.readAsBinaryString(file);
      },
    },
  },
  filters: {
    json(a) {
      try {
        return a ? JSON.stringify(a) : "";
      } catch (error) {
        return "";
      }
    },
  },
  computed: {
    ekk_frames() {
      if (!this.$store.getters["admin/isEkkframes"])
        this.$store.dispatch("admin/LOAD_EKKFRAMES");
      return this.$store.getters["admin/ekkframes"](this.currentDomen);
    },
    cardautosuffix: {
      get() {
        if (!this.item.params) return false;
        if (this.item.params.cardautosuffix == undefined) return false;
        return this.item.params.cardautosuffix;
      },
      set(v) {
        if (!this.item.params) this.item.params = {};
        this.item.params.cardautosuffix = v;
      },
    },
    excel_headers() {
      if (!this.excel_json.length) return ["no headers"];
      let a = [];
      for (let h in this.excel_json[0]) {
        a.push(h);
      }
      return a;
    },
    excel_page() {
      try {
        return this.excel_json.slice(
          this.excel_max * (this.excel_cur_page - 1),
          this.excel_max * this.excel_cur_page
        );
      } catch (error) {
        console.log(error);
      }
      return [];
    },
    walletSourceText: {
      get() {
        try {
          return JSON.stringify(this.walletSource);
        } catch (error) {
          return "";
        }
      },
      set(v) {
        this.walletSource = JSON.parse(v);
      },
    },
    bins() {
      return this.$store.getters["admin/bins"];
    },
  },
  methods: {
    colorForHeader(h) {
      try {
        if (h == this.excelField) return "success";
      } catch (error) {
        console.log(error);
      }
      return "";
    },
    addCodes() {
      this.$api
        .addCodes(this.currentBin, {
          field: this.excelField,
          data: this.excel_json,
          qrcode: this.excel_qrcode,
          barcode: this.excel_barcode,
          frame: this.excel_frame ? this.excel_frame.code : null,
          ft: this.excel_frame ? this.excel_frame.format : null,
        })
        .then((r) => {
          try {
            this.excel_json = [...r];
            var ws = XLSX.utils.json_to_sheet(r);
            XLSX.utils.book_append_sheet(
              this.workbook,
              ws,
              "codes_" + new Date().toISOString()
            );
          } catch (error) {
            alert(error);
          }
        });
    },
    saveExcel() {
      if (this.excel_file) {
        XLSX.writeFile(this.workbook, "with_qr_links_" + this.excel_file.name);
      }
    },
    generateCodes(item) {
      this.currentBin = item.bin;
      this.currentDomen = item.domen;
      this.cardCodes = null;
      this.pdf_card = null;
      this.excel_frame = null;
      this.d_generate_codes = true;
    },
    getCardCodes() {
      this.$api
        .getCodesForCard(this.currentBin, this.pdf_card, this.excel_frame)
        .then((response) => {
          this.cardCodes = { ...response };
        });
    },
    excelService(item) {
      this.currentBin = item.bin;
      this.currentDomen = item.domen;
      this.excel_file = null;
      this.dexcel = true;
    },
    uploadImgs() {
      //console.log(this.currentBin, this.images);
      this.$api.loadWalletImages(this.currentBin, this.images);
    },
    uploadTpl() {
      if (!this.currentBin) return;
      const file = new File([...this.templateSource], "template.html", {
        type: "html/text",
      });
      this.$api.uploadBinTemplate({
        item: { bin: this.currentBin },
        file: file,
      });
    },
    setWalletTpl() {
      if (!this.currentBin) return;
      this.$api.setWalletTemplateSource(this.currentBin, this.walletSource);
    },
    editWalletTpl(i) {
      this.currentBin = i;
      this.$api.getWalletTemplateSource(i).then((r) => {
        this.walletSource = r;
        this.dwallet = true;
      });
    },
    editTpl(i) {
      this.currentBin = i;
      this.$api.getTemplateSource(i).then((r) => {
        this.templateSource = r;
        this.dedittpl = true;
      });
    },
    upload() {
      this.$api.uploadBinTemplate({
        item: { bin: this.templateBin },
        file: this.template,
      });
      this.dupload = false;
    },
    showPdf() {
      let url = this.$api.api + "/auth/cms/bins/show/pdf/" + this.templateBin;
      url += "?locale=" + this.pdf_lang;
      url += this.pdf_card ? "&incard=" + this.templateBin + this.pdf_card : "";
      url += this.pdf_ref ? "&ref=" + this.pdf_ref : "";
      window.open(url);
      this.templateBin = "";
      this.pdf_card = "";
      this.pdf_ref = "";
      this.d_genereate_pdf = false;
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.bins.indexOf(i);
      //console.log(this.currentIdx, this.item);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_BIN", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      if (this.currentIdx != -1) {
        this.$store
          .dispatch("admin/UPDATE_BIN", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.items.find((e) => {
          return e.bin == this.item.bin;
        });
        if (prev) {
          this.filial_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_BIN", this.item)
            .then((response) => {
              if (response == 0) {
                this.filial_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("admin/LOAD_BINS");
  },
};
</script>

<style scoped>
</style>